import { FlowType } from "@redotech/redo-return-core-common/return-flow-enums";
import { RedoTextareaInputField } from "@redotech/redo-web/arbiter-components/input/redo-textarea-input-field";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo } from "react";
import { FlowFieldTranslations } from "./flow-field-translations";
import { FlowTranslatableFieldSpec } from "./translation-save-diff";

/** Labeled textarea whose current text comes from `field.source`, with the "View translations" link. */
export const TranslatableTextareaField = memo(
  function TranslatableTextareaField({
    field,
    setValue,
    elementId,
    stepElementIds,
    flowType,
    canEdit,
    errorText,
    placeholder,
    helperText,
  }: {
    field: FlowTranslatableFieldSpec;
    setValue(value: string): void;
    elementId: string | undefined;
    stepElementIds: readonly string[];
    flowType: FlowType;
    canEdit: boolean;
    errorText?: string;
    placeholder?: string;
    helperText?: string;
  }) {
    return (
      <Flex dir="column" gap="xs">
        <Text fontSize="xs" fontWeight="medium" textColor="secondary">
          {field.label}
        </Text>
        <RedoTextareaInputField
          errorText={errorText}
          placeholder={placeholder}
          readOnly={!canEdit}
          setValue={setValue}
          value={field.source}
        />
        {helperText && (
          <Text fontSize="xxs" textColor="secondary">
            {helperText}
          </Text>
        )}
        <FlowFieldTranslations
          canEdit={canEdit}
          elementId={elementId}
          field={field}
          flowType={flowType}
          stepElementIds={stepElementIds}
        />
      </Flex>
    );
  },
);
